/**
 * Trip cover URL heuristics.
 *
 * v1 (RN) trips stored auto-generated Unsplash URLs via `source.unsplash.com/…`,
 * a service Unsplash retired in mid-2024. Those URLs now return zero bytes /
 * a 404 / a redirect to nothing, and rendering them shows a broken-image glyph.
 *
 * We detect the obvious losers up front (fast, no network) and also fall back
 * to the gradient stand-in on any runtime `onError` — see TripCard. This util
 * covers the "before the image tries to load" case.
 */

const BROKEN_HOST_PATTERNS: readonly RegExp[] = [
  /(^|\/\/)source\.unsplash\.com\b/i, // retired Unsplash source endpoint
];

export function isLikelyBrokenCoverUrl(url: string | null | undefined): boolean {
  if (!url) return true;
  const trimmed = url.trim();
  if (!trimmed) return true;
  if (trimmed === "null" || trimmed === "undefined") return true;
  return BROKEN_HOST_PATTERNS.some((re) => re.test(trimmed));
}
